// libs
import { styled } from '@nykaa/ui-components';

// global components
import Wishlist from 'shared/components/Wishlist';

//hook
import { BREAKPOINTS } from 'shared/styles/base';

export const CustomWishlist = styled(Wishlist)`
  width: 32px;
  height: 32px;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    right: 8px;
    top: 8px;
    z-index: 1;
  }

  & .circle {
    border-radius: ${({ theme }) => theme.borders.radiusFull};
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.92;
    background-color: ${({ theme }) => theme.colors.surface10};
  }
`;
